export const handleFloatingBtn = (e) => {

  const btns = document.querySelectorAll('.floating-btn')

  btns.forEach((btn) => {

    const isAnnualHero = btn.hasAttribute('data-annual-hero')

    if (e?.type === 'resize') {
      btn.style.transition = 'none'
    } else {
      btn.style.transition = null
    }

    const floatingPos = {
      top: `${window.innerHeight - btn.scrollHeight - 32}px`,
      left: `${window.innerWidth - btn.scrollWidth - 32}px`
    }
    const initialPos = {top: null, left: null}
    const footerStartingPos = document.querySelector('.microsite-footer').offsetTop

    if (!isAnnualHero) {
      const container = document.querySelector('.hero-block .container-full .row')
      const content = document.querySelector('.hero-block .container-full .content')

      initialPos.top = `${container.offsetTop + container.offsetHeight}px`,
      initialPos.left = `${content.getBoundingClientRect().x}px`

    } else {
      initialPos.left = `${document.querySelector('h1').offsetLeft}px`;
      initialPos.top = `${document.querySelector('.blurb-container .blurb').getBoundingClientRect().bottom}px`
    }

    if (window.scrollY > 10 || btn.classList.contains('float')) {
      btn.classList.add('floating')
      btn.style.left = floatingPos.left
      btn.style.top = floatingPos.top
    } else {
      btn.classList.remove('floating')
      btn.style.left = initialPos.left
      btn.style.top = initialPos.top
    }

    if (footerStartingPos < (window.scrollY + window.innerHeight)) {
      btn.classList.add('fade-away')
    } else {
      btn.classList.remove('fade-away')
    }
  })
}

export const addActiveClassToMenuItem = () => {

  let minPos = null
  let minPosEl = null

  document.querySelectorAll('main > section[data-anchor]').forEach((section) => {
    const sectionPosition = section.offsetTop + section.scrollHeight - window.scrollY
    if (sectionPosition >= 0 && (!minPos || sectionPosition < minPos)) {
      minPos = sectionPosition
      minPosEl = section
    }
  })

  const minPosAnchor = minPosEl.getAttribute('data-anchor')
  const newActiveItem = document.querySelector(`.main-nav-list-item[data-menuanchor="${minPosAnchor}"]`)
  if (newActiveItem) {
    const newSectionName = newActiveItem.querySelector('a').innerText

    document.querySelectorAll(`.main-nav-list-item:not([data-menuanchor="${minPosAnchor}"])`).forEach(item => item.classList.remove('active'))
    newActiveItem.classList.add('active')

    const sectionNameEl = document.querySelector('header .section-name')
    if (sectionNameEl.textContent !== newSectionName) {
      sectionNameEl.textContent = newSectionName
    }
  }
}

export const addNavScrollingClasses = (navbar, lastScrollPos) => {
  if (window.scrollY > lastScrollPos) {
    navbar.classList.add('scrolling-down');
    navbar.classList.remove('scrolling-up');
  } else {
    navbar.classList.add('scrolling-up');
    navbar.classList.remove('scrolling-down');
  }

  const heroContainer = document.querySelector('#heroContainer')
  if (heroContainer) {
    if (window.scrollY <= heroContainer.scrollHeight - 100) {
      navbar.classList.remove('scrolling-under-hero');
    }
    else {
      document.body.classList.add('scrolled-after-hero');
      navbar.classList.add('scrolling-under-hero');
    }

    if (window.scrollY <= 100) {
      navbar.classList.remove('scrolling');
    }
    else {
      navbar.classList.add('scrolling');
    }
  }
}

export const addScrollOffset = () => {
  const htmlEl = document.querySelector('html')
  if (htmlEl.classList.contains('no-pagepiling')) {
    htmlEl.style.scrollPaddingTop = `${document.querySelector('header').scrollHeight}px`
  }
}